import { RightPage } from "@/UDTreat/right/RightPage"
import MyAccordion from "./MyAccordion"

import { useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import { EArchType, wasmModule } from "@/gluelayer"
import { useMemo } from "react"

import "./index.scss"

export const UDSetup = (props) => {
  const { curArch: curArchFromStore, singleArchBool } = useAppSelector(
    (state: RootState) => state.udTreatService,
  )

  const curArch = useMemo(() => {
    const hasUpper = wasmModule.getArchModel(EArchType.UpArch)
    const hasLower = wasmModule.getArchModel(EArchType.LowArch)
    if (singleArchBool) {
      if (hasUpper) {
        return "up"
      }
      if (hasLower) {
        return "low"
      }
    } else {
      return curArchFromStore
    }
  }, [curArchFromStore])

  return (
    <RightPage
      title="Setup"
      onClose={props.onClose}
      className="ud-setup-model"
      bodyClassName="ud-setup-model-body"
      content={
        <div className="ud-setup-model-body-content">
          <MyAccordion curArch={curArch} />
        </div>
      }
    />
  )
}
